import { getParsedCookies } from './cookie'

interface PaneElementProps {
  type: string
  label?: string
  fromDate?: string
  toDate?: string
  min?: number
  tickers: string[]
  overlays: string[]
}

export enum SpecificChartFunctionality {
  default = 'default',
  quotePage = 'quotePage',
  chartPage = 'chartPage',
  smallIndex = 'smallIndex',
  offScreen = 'offScreen',
  forexPage = 'forexPage',
  futuresPage = 'futuresPage',
  cryptoPage = 'cryptoPage',
}

interface StaticChartConfigProps {
  width?: number
  height?: number
  ticker: string
  timeframe: string
  paneElements: PaneElementProps[]
  specificChartFunctionality?: SpecificChartFunctionality
  colorsOverride?: Array<string>
  theme?: 'dark' | 'light'
  colors?: ReturnType<typeof getCustomColorsFromCookies>
}

export function getStaticChartConfig({
  width = 800,
  height = 400,
  ticker,
  timeframe,
  paneElements,
  specificChartFunctionality = SpecificChartFunctionality.default,
  colorsOverride,
  theme,
  colors = getCustomColorsFromCookies(),
}: StaticChartConfigProps) {
  return {
    layout: '1h1v',
    width,
    height,
    barWidth: 1,
    barMargin: 0,
    scrollable: false,
    editable: false,
    specificChartFunctionality,
    colorsOverride,
    theme,
    colors,
    charts: [
      {
        height,
        timeframe,
        scale: 'linear',
        ticker: ticker,
        leftOffset: 0,
        instrument: 'stock',
        refreshData: false,
        stretch: true,
        panes: [
          {
            height,
            elements: paneElements,
          },
        ],
      },
    ],
  }
}

export function getCustomColorsFromCookies() {
  try {
    return JSON.parse(getParsedCookies('customColors') as string)
  } catch {
    return undefined
  }
}
